import Vue from 'vue';
import Vuetify, { VSnackbar } from 'vuetify/lib';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { preset } from 'vue-cli-plugin-vuetify-preset-crane/preset'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
  },
});

export default new Vuetify({
  // preset,
  theme: { dark: false },
});
